<div class="container-fluid">
    <div class="row">
        <div class="col-8">
            <app-pagetitle title="Roles"></app-pagetitle>
        </div>

    </div>

    <!-- <div class="col-4">
        <button class="btn btn-primary btn-sm float-end" (click)="openCreateModal(planModal)">
            <i class="mdi mdi-plus"></i> Add Role
        </button>
    </div> -->

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">


            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" searchBY="Name, Email, Role"
                                [statusOptions]="statusOptions"></app-filter>

                            <p-table #dt [value]="users" [lazy]="true" (onLazyLoad)="getUsers($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>Status</th>
                                        <th>Created At</th>
                                        <th>Updated At</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-data>
                                    <tr>
                                        <td>{{ data.name | titlecase}}</td>
                                        <td>{{ data.email }}</td>
                                        <td>{{ data.role }}</td>
                                        <td>

                                            <span class="badge" [ngClass]="{
                                        'bg-warning': data.status === 'PENDING',
                                        'bg-success': data.status === 'ACTIVE',
                                        'bg-danger': data.status === 'REJECTED'
                                    }">

                                                {{ data.status }}

                                            </span>

                                        </td>
                                        <td>{{ data.createdAt | date:'short' }}</td>
                                        <td>{{ data.updatedAt | date:'short' }}</td>

                                        <td class="d-flex align-items-center gap-2">

                                            <!-- <div class="form-check form-switch cursor-pointer">
                                        <input class="form-check-input cursor-pointer" type="checkbox"
                                            [checked]="data.status !== 'Inactive'"
                                            (change)="toggleUserStatus(data, $event)" [ngbTooltip]="data.status !== 'Inactive'
                                  ? 'Deactivate'
                                  : 'Activate'" />
                                    </div> -->

                                            <a href="javascript:void(0);" class="text-primary"
                                                (click)="openEditModal(data, userModal)" ngbTooltip="Detail">
                                                <i class="mdi mdi-information font-size-18"></i>
                                            </a>

                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No Data found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #userModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">User Detail</h5>

                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
                </button>
            </div>

            <div class="modal-body">

                <div class="row">

                    <!-- Name -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Name</div>
                        <div>{{ userDetail?.name || '-' }}</div>
                    </div>

                    <!-- Email -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Email</div>
                        <div>{{ userDetail?.email || '-' }}</div>
                    </div>

                    <!-- Role -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Role</div>
                        <div>
                            <span class="badge bg-primary">
                                {{ userDetail?.role || '-' }}
                            </span>
                        </div>
                    </div>

                    <!-- Status -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Status</div>

                        <span class="badge" [ngClass]="userDetail?.status === 'ACTIVE'
                    ? 'bg-success'
                    : 'bg-danger'">

                            {{ userDetail?.status || '-' }}
                        </span>
                    </div>

                    <!-- Approved States -->
                    <!-- @if(userDetail?.approvedStates?.length > 0){
            <div class="col-md-12 mb-3">
                <div class="fw-semibold">Approved States</div>

                <div class="d-flex flex-wrap gap-2 mt-1">
                    @for(state of userDetail?.approvedStates; track state){
                    <span class="badge bg-info">

                        {{ state }}
                    </span>
                    }

                </div>
            </div>
            } -->
                    <!-- @if(!userDetail?.approvedStates?.length && userDetail?.status !='REJECTED'){
            <div class="col-md-12 mb-3">
                <div class="fw-semibold">Request States</div>

                <div class="d-flex flex-wrap gap-2 mt-1">
                    @for(state of userDetail?.states; track state){
                    <b>
                        {{ state }}
                    </b>
                    }
                </div>
            </div>
            <div class="row align-items-start">
                <div class="col-md-8 mb-3">
                    <div class="position-relative" #stateDropdown>
                        <div class="form-select d-flex align-items-center justify-content-between" role="button"
                            (click)="showDropdown = !showDropdown">

                            <span>
                                Select States
                            </span>
                        </div>

                        <div class="border rounded bg-white shadow-sm position-absolute w-100 mt-1 p-2"
                            *ngIf="showDropdown" style="z-index: 1050; max-height: 250px; overflow-y: auto;">

                            @for(state of states; track state._id){

                            <div class="form-check mb-2">

                                <input class="form-check-input" type="checkbox" [id]="state._id"
                                    [checked]="selectedStateIds.includes(state._id)"
                                    (change)="onStateChange($event, state)" />

                                <label class="form-check-label" [for]="state._id">

                                    {{ state.name }} ({{ state.key }})

                                </label>

                            </div>

                            }

                        </div>

                    </div>

                    <div class="mt-2 text-muted small" *ngIf="selectedStateNames.length">

                        Selected:
                        {{ selectedStateNames.join(', ') }}

                    </div>

                </div>           

            </div>
            } -->
                    <!-- Email Verified -->
                    <div class="col-md-12 mb-3">
                        <div class="fw-semibold">Email Verified</div>

                        <span class="badge" [ngClass]="userDetail?.isEmailVerified
                    ? 'bg-success'
                    : 'bg-warning'">

                            {{ userDetail?.isEmailVerified ? 'Verified' : 'Not Verified' }}
                        </span>
                    </div>

                    <!-- Created At -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Created At</div>

                        <div>
                            {{ userDetail?.createdAt | date:'medium' }}
                        </div>
                    </div>

                    <!-- Updated At -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Updated At</div>

                        <div>
                            {{ userDetail?.updatedAt | date:'medium' }}
                        </div>
                    </div>

                    @if(userDetail?.status !== 'ACTIVE'){
                    <div class="col-md-12 d-flex gap-3 mb-1">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="userAction" id="actionApprove"
                                value="APPROVE" [(ngModel)]="selectedAction">
                            <label class="form-check-label" for="actionApprove">Approve</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="userAction" id="actionReject"
                                value="REJECT" [(ngModel)]="selectedAction">
                            <label class="form-check-label" for="actionReject">Reject</label>
                        </div>
                    </div>

                    @if(selectedAction === 'REJECT'){
                    <div class="col-md-12 mb-3">
                        <label class="form-label fw-semibold mb-1">Reject Reason</label>
                        <input type="text" class="form-control mb-2" placeholder="Enter reject reason"
                            [(ngModel)]="rejectMessage">
                        <button class="btn btn-danger btn-sm" (click)="rejectedStateReq()">
                            Submit
                        </button>
                    </div>
                    }
                    @else if(selectedAction === 'APPROVE'){
                    <div class="col-md-12 mb-3">
                        <button class="btn btn-primary btn-sm" (click)="approvedStates()">
                            Submit
                        </button>
                    </div>
                    }

                    }

                </div>

            </div>
        </ng-template>
    </div>

</div>